import api from '../api.js';

export const authenticationRequests = {
  login: (username, password) => {
    const params = { username, password };
    return api.post('/auth/login', params);
  }
};

export default authenticationRequests;
